import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../messages';

import style from './verification-notifier.module.less';

export const VerificationNotifier = ({ name, closeNotification }) => (
  <div className={style['verification-notification']}>
    <div className={style['verification-text']}>
      <span>
        <FormattedMessage {...messages.verificationMessage} />
      </span>
      <span className={style['item-name']}>{name}</span>
    </div>
    <div onClick={closeNotification}>
      <FontAwesomeIcon icon={faXmark} onClick={closeNotification} />
    </div>
  </div>
);

VerificationNotifier.propTypes = {
  name: PropTypes.string.isRequired,
  closeNotification: PropTypes.func.isRequired,
};
